import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import * as Icons from 'lucide-react';
import { SiTiktok, SiX } from 'react-icons/si';
import { mockGames } from '../mock/mockData';


const ProjectList = ({ navigate }) => {
  // Seřadíme projekty podle ID (od nejmenšího po největší)
  const sortedGames = [...mockGames].sort((a, b) => a.id - b.id);

  // Vybereme maximálně 5 položek
  const visibleGames = sortedGames.slice(0, 5);

  return (
    <ul className="space-y-2">
      {visibleGames.map((game) => (
        <li key={game.id}>
          <button
            href="/#games"
            onClick={(e) => {
              window.scrollTo({ top: 0, behavior: 'smooth' }); // ✅ plynulé scrollnutí
              navigate(`/game/${game.gamePath}`);
            }}
            className="text-gray-400 hover:text-red-500 transition-colors text-sm cursor-pointer"
          >
            {game.title}
          </button>
        </li>
      ))}
    </ul>
  );
};



const Footer = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  const scrollToGames = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/#games');
    } else {
      const gamesSection = document.getElementById('games');
      if (gamesSection) {
        gamesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const socialLinks = [
    { icon: SiX, url: 'https://x.com/SillyHatStudio', label: 'X', size: 15 },
    { icon: Icons.Youtube, url: 'https://www.youtube.com/@studiosillyhat', label: 'YouTube' },
    { icon: Icons.Instagram, url: 'https://www.instagram.com/sillyhatstudio/', label: 'Instagram' },
    { icon: SiTiktok, url: 'https://www.tiktok.com/@sillyhatstudio', label: 'Tiktok', size: 15 },

  ];

  return (
    <footer className="bg-black border-t border-red-900/20 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="/logo.png"
                alt="Silly Hat Studio"
                className="h-10 w-10 object-contain"
              />
              <span className="text-lg font-bold text-red-600">
                Silly Hat Studio
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('hero.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">
              {t('nav.games')}
            </h3>
            <ProjectList navigate={navigate} />
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">
              {t('footer.follow')}
            </h3>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target='_blank'
                  aria-label={social.label}
                  className="w-10 h-10 rounded-lg bg-red-900/20 hover:bg-red-900/40 flex items-center justify-center text-red-500 transition-colors"
                >
                  <social.icon size={social.size ?? 18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-red-900/20 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Silly Hat Studio. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;